// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bcQs","right":"styles_right__23Upi"};